const CHATSERVER_BASE_URL = window.config.CHATSERVER_BASE_URL,
    CHATSERVER_JWT = window.config.CHATSERVER_JWT,
    INPUT_OPTIONS = require('./rescheduledelivery-setup'),
    _ = require('lodash');

function RescheduleDelivery(Restangular,ProxyService, $http) {
    this._api = Restangular.one('shopper');
    this._deliveryInfoApi = Restangular.one('Delivery');
    this.proxyService = ProxyService;
    this.$http = $http;
    this.resheduleDeliveryURL = `${CHATSERVER_BASE_URL}/api/Zendesk/PostCreateTicket`;
    this.redeliveryCutOffURL = `${CHATSERVER_BASE_URL}/api/Azure/GetRedeliveryCutOff`;
}

RescheduleDelivery.prototype.getFieldId = function (key) {
    return INPUT_OPTIONS[key] && INPUT_OPTIONS[key].fieldId ? INPUT_OPTIONS[key].fieldId : undefined;
};

RescheduleDelivery.prototype.OrdersReschedule = function (id) {
    return this._api.one('OrdersReschedule').get({
        Id: id
    });
};

const getTicketBodyContent = (selected) => {
    const deliveryDay = selected.deliveryDay.value;
    const deliveryTime = selected.deliveryTime.value;
    let isActive = '';

    switch (selected.isActive) {
        case 'pickUpFromStore':
            isActive = 'Pick up from the store';
            break;
        case 'reDeliver':
            isActive = 'Re deliver to the same address';
            break;
        case 'cancelOrder':
            isActive = 'Cancel my order';
            break;
        default:
            isActive = '';
    }
    return `How would you like to receive your product: ${isActive}\n
    Preferred delivery day: ${deliveryDay !== '' ? deliveryDay : 'N/A'}\n
    Preferred delivery time: ${deliveryTime !== '' ? deliveryTime : 'N/A'}\n
    Customer comments: ${selected.comment.body}`;
};

RescheduleDelivery.prototype.rescheduledConfirmed = function (dto) {    
    return this._deliveryInfoApi.one('ModifyDeliveryBooking').customPUT(dto);
};

RescheduleDelivery.prototype.rescheduledConfirmedYello = function (dto) {    
    return this._deliveryInfoApi.one('ReCreateYellowBookDelivery').customPUT(dto);
};

RescheduleDelivery.prototype.confirmPick = function (selected) {
    const subjectValue = 'Help Centre: Delivery now contact form';
    const ticketRequest = {
        appName: 'BWSUI',
        ticket: {
            subject: subjectValue,
            comment: {
                body: getTicketBodyContent(selected)
            },
            brand_id: this.getFieldId('brand_id'),
            ticket_form_id: this.getFieldId('ticket_form_id'),
            orderNumber: selected.orderNumber,
            custom_fields: []
        }
    };


    ticketRequest.ticket.requester = {
        name: `${selected.FirstName} ${selected.LastName}`,
        email: selected.Email
    };

    ticketRequest.ticket.custom_fields.push({
        id: 360000211996,
        value: 'delivery___pick_up_from_store'
    },
        {
            id: 360000208455,
            value: 'i_want_to_change_my_delivery'
        }
    );

    //Other fields
    _.mapKeys(selected, (selectedValue, key) => {
        if (selectedValue && this.getFieldId(key)) {
            const id = this.getFieldId(key);
            let value = selectedValue.value ? selectedValue.value : selectedValue;
            if (value.label && value.label === '-') {
                value = null;
            }
            if (value) {
                ticketRequest.ticket.custom_fields.push({
                    id,
                    value
                });
            }
        }
    });

    return this.$http.post(this.resheduleDeliveryURL, ticketRequest, { headers: { 'Ocp-Apim-Subscription-Key': CHATSERVER_JWT } });
};

RescheduleDelivery.prototype.cancelConfirmed = function (selected) {
    const subjectValue = 'Help Centre: Delivery now contact form';
    const ticketRequest = {
        appName: 'BWSUI',
        ticket: {
            subject: subjectValue,
            comment: {
                body: getTicketBodyContent(selected)
            },
            brand_id: this.getFieldId('brand_id'),
            ticket_form_id: this.getFieldId('ticket_form_id'),
            orderNumber: selected.orderNumber,
            custom_fields: []
        }
    };


    ticketRequest.ticket.requester = {
        name: `${selected.FirstName} ${selected.LastName}`,
        email: selected.Email
    };

    ticketRequest.ticket.custom_fields.push({
        id: 360000211996,
        value: 'delivery___pick_up_from_store'
    },
        {
            id: 360000208455,
            value: 'i_want_to_change_my_delivery'
        }
    );

    //Other fields
    _.mapKeys(selected, (selectedValue, key) => {
        if (selectedValue && this.getFieldId(key)) {
            const id = this.getFieldId(key);
            let value = selectedValue.value ? selectedValue.value : selectedValue;
            if (value.label && value.label === '-') {
                value = null;
            }
            if (value) {
                ticketRequest.ticket.custom_fields.push({
                    id,
                    value
                });
            }
        }
    });

    return this.$http.post(this.resheduleDeliveryURL, ticketRequest, { headers: { 'Ocp-Apim-Subscription-Key': CHATSERVER_JWT } });
};

module.exports = RescheduleDelivery;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduledelivery/rescheduledelivery-service.js
 **/